/**
 * Generic analytics handler for tracking clicks and navigation
 * @param {string} eventType - The type of event to track
 * @param {Object} eventParams - Parameters to send with the event
 * @param {Event} event - The click event object
 */
export const handleAnalyticsClick = (eventType, eventParams, event) => {
    // Prevent default navigation
    event.preventDefault();

    // Find the closest anchor tag from the clicked element
    const anchorTag = event.target.closest('a');
    const targetUrl = anchorTag ? anchorTag.href : null;

    if (targetUrl) {
        // Send analytics event if gtag is available
        if (window.gtag) {
            window.gtag('event', eventType, eventParams);
        } else {
            console.warn('Google Analytics (window.gtag) not found.');
        }

        // Navigate after a small delay to allow analytics to fire
        setTimeout(() => {
            window.location.href = targetUrl;
        }, 250);
    } else {
        console.warn('No anchor tag found for navigation');
    }
};

/**
 * Alternative version that takes a custom URL instead of finding it from the event
 * @param {string} eventType - The type of event to track
 * @param {Object} eventParams - Parameters to send with the event
 * @param {string} targetUrl - The URL to navigate to
 */
export const handleAnalyticsNavigation = (eventType, eventParams, targetUrl) => {
    if (targetUrl) {
        // Send analytics event if gtag is available
        if (window.gtag) {
            window.gtag('event', eventType, eventParams);
        } else {
            console.warn('Google Analytics (window.gtag) not found.');
        }

        // Navigate after a small delay to allow analytics to fire
        setTimeout(() => {
            window.location.href = targetUrl;
        }, 250);
    } else {
        console.warn('No target URL provided for navigation');
    }
}; 